import FirestoreCollectionStore from '../../../modules/vuex-firestore/FirestoreCollectionStore'
import { timestamp as fstime } from '../../../modules/firebase/core'

const state = {}

const mutations = {}

const getters = {
  filtered: (state, getters) => filterText => {
    return getters['$sorted'].filter((scene) => {
      return scene.name.indexOf(filterText) > -1
    })
  }
}

const actions = {
  save({ rootGetters, dispatch }, key) {
    const imageObjectList = rootGetters['imageObjectList/$items'].filter(imageObject => imageObject.pinnedInScene === true)
    const room = rootGetters['room/data']
    return dispatch('$update', { key, data: { room, imageObjectList } })
  },
  restore({ rootGetters, getters, dispatch }, key) {
    const scene = getters.$get(key)
    if (!scene) return Promise.reject()
    const room = scene.room
    const independentImageObjectListKeys = rootGetters['imageObjectList/$items'].filter(imageObject => imageObject.pinnedInScene === false).map(({ key }) => { return key })
    const savedImageObjectList = scene.imageObjectList.filter(imageObject => !independentImageObjectListKeys.includes(imageObject.key))
    const imageObjectListKeys = savedImageObjectList.map(({ key }) => { return key }).concat(independentImageObjectListKeys)
    const deleteTask = dispatch('imageObjectList/$filter', imageObjectListKeys, { root: true })
    const imageObjectListTasks = savedImageObjectList.map(imageObject => {
      return dispatch('imageObjectList/$insert', {
        key: imageObject.key,
        data: {
          ...imageObject,
          pinnedInScene: true
        }
      }, { root: true })
    })
    const roomTask = dispatch('room/$update', room, { root: true })
    return Promise.all([roomTask, deleteTask, ...imageObjectListTasks])
  },
  restoreOnlyImage({ rootGetters, getters, dispatch }, key) {
    const scene = getters.$get(key)
    if (!scene) return Promise.reject()
    const independentImageObjectListKeys = rootGetters['imageObjectList/$items'].filter(imageObject => imageObject.pinnedInScene === false).map(({ key }) => { return key })
    const savedImageObjectList = scene.imageObjectList.filter(imageObject => !independentImageObjectListKeys.includes(imageObject.key))
    const room = {
      ...scene.room
    }
    delete room['bgm01SoundKey']
    delete room['bgm02SoundKey']
    delete room['se01SoundKey']
    const imageObjectListKeys = savedImageObjectList.map(({ key }) => { return key }).concat(independentImageObjectListKeys)
    const deleteTask = dispatch('imageObjectList/$filter', imageObjectListKeys, { root: true })
    const imageObjectListTasks = savedImageObjectList.map(imageObject => {
      return dispatch('imageObjectList/$insert', {
        key: imageObject.key,
        data: {
          ...imageObject,
          pinnedInScene: true
        }
      }, { root: true })
    })
    const roomTask = dispatch('room/$update', room, { root: true })
    return Promise.all([roomTask, deleteTask, ...imageObjectListTasks])
  }
}

function formatter({
  name = 'kari',
  room = {
    tableBackgroundImageKey: null,
    tableImageKey: null,
    tableRatio: '16:9',
    tableMode: '2d',
    bgm01SoundKey: null,
    bgm02SoundKey: null,
    se01SoundKey: null
  },
  imageObjectList = [],
  timestamp,
  order = 0
}) {
  const _timestamp = timestamp || fstime.fromMillis(Date.now())
  return {
    name,
    room,
    imageObjectList,
    order,
    timestamp: _timestamp
  }
}

export default new FirestoreCollectionStore({
  $name: 'scenes',
  $formatter: formatter,
  $sortKey: 'order',
  state,
  mutations,
  getters,
  actions
})
